import EthereumService from '@/services/ethereum'
import cookie from '@/utils/cookie'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
  }
  async updateUserData () {
    try {
      if (cookie.get('accessToken') && cookie.get('user')) {
        const { data } = await this.kulapApi.getUserProfile()
        this.store.dispatch('setUser', data)
        return data
      } else {
        this.store.dispatch('setUser', {})
      }
    } catch (e) {
      this.logout()
    }
  }
  logout () {
    this.kulapApi.postLogout()
    cookie.remove('accessToken')
    cookie.remove('user')
    this.updateUserData()
  }

  async sendConfirmationEmail (recaptchaToken) {
    const { data } = await this.kulapApi.sendConfirmationEmail(recaptchaToken)
    return data
  }

  async getUserProfile () {
    const { data } = await this.kulapApi.getUserProfile()
    this.store.dispatch('setUser', data)
    return data
  }
}



// WEBPACK FOOTER //
// ./src/pages/RegisterStatus/service.js